export enum UserActivityViewEnum {
    Yesterday = 0,
    Today = 1,
    LastWeek = 2,
    ThisWeek = 3
}